import { Navbar } from "../components/Navbar";
import { Footer } from "../components/Footer";
import { Droplets, Check, MessageCircle } from "lucide-react";
import { CAR_WASH_SERVICES, whatsappLink } from "../data/site";
import { useLang } from "../context/LanguageContext";

const WASH_BG = "/images/gallery/fb-shop-navi.jpg";

export default function CarWash() {
  const { t } = useLang();
  return (
    <div className="App">
      <Navbar />

      <section className="relative py-24 overflow-hidden">
        <div className="absolute inset-0">
          <img src={WASH_BG} alt="Car wash" className="w-full h-full object-cover" />
          <div className="absolute inset-0 bg-gradient-to-r from-brand-blue/90 to-brand-sky/60" />
        </div>
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-white">
          <span className="inline-flex items-center gap-2 text-white/90 font-heading font-bold uppercase tracking-[0.2em] text-sm">
            <Droplets size={16} /> {t.carwash.tag}
          </span>
          <h1 className="font-heading font-black text-4xl sm:text-5xl mt-3 max-w-2xl">{t.carwash.title}</h1>
          <p className="text-white/85 mt-4 max-w-xl">{t.carwash.subtitle}</p>
          <a
            href={whatsappLink(t.wa.carwash)}
            target="_blank"
            rel="noreferrer"
            data-testid="carwash-cta"
            className="inline-flex items-center gap-2 mt-7 bg-brand-orange hover:bg-brand-orange/90 text-white font-heading font-bold py-3 px-7 rounded-full transition-colors"
          >
            <MessageCircle size={18} /> {t.carwash.cta}
          </a>
        </div>
      </section>

      <section className="py-20">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="font-heading font-black text-3xl text-brand-gray text-center mb-12">{t.carwash.pricingTitle}</h2>
          <div className="space-y-4">
            {CAR_WASH_SERVICES.map((s, i) => (
              <div
                key={i}
                data-testid={`carwash-item-${i}`}
                className="flex items-center justify-between gap-4 bg-white border border-slate-100 rounded-2xl p-6 shadow-sm hover:shadow-md transition-shadow"
              >
                <div className="flex items-start gap-4">
                  <div className="bg-brand-sky/15 text-brand-blue p-3 rounded-xl"><Check size={22} /></div>
                  <div>
                    <h3 className="font-heading font-bold text-lg text-brand-gray">{t.carwash.services[i].name}</h3>
                    <p className="text-slate-500 text-sm mt-0.5">{t.carwash.services[i].desc}</p>
                  </div>
                </div>
                <div className="text-right shrink-0">
                  <div className="font-heading font-black text-2xl text-brand-blue">C${s.price}</div>
                  <div className="text-xs text-slate-400">{t.common.nio}</div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
